import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { GROWTH_BOOK_FEATURE_FLAG_NAMES } from "constants/index";

const useShowSmartQuestions = () => {
  const isSmartQuestionsEnabled = useFeatureIsOn(GROWTH_BOOK_FEATURE_FLAG_NAMES.SMART_QUESTIONS);

  return isSmartQuestionsEnabled;
};

export default useShowSmartQuestions;
